import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CallIcon from "@mui/icons-material/Call";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import EditIcon from "@mui/icons-material/Edit";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import MailIcon from "@mui/icons-material/Mail";
import { Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import { ReactComponent as ChangePasswordIcon } from "../../../assets/images/svg/change-password.svg";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomTextField from "../../../components/CustomTextField";
import CustomUpload from "../../../components/CustomUpload";
import { default as Select } from "../../../components/Select/Select";
import { forgotPassword } from "../../../redux/reducers/authSlice";
import { createNewChat } from "../../../redux/reducers/chatSlice";
import {
  getClinicRoles,
  getRecentTransactionsPayment,
  getVetDetailsById,
  getVetUpcomingAppointmentsById,
} from "../../../redux/reducers/clinicSlice";
import {
  updateVetBlockStatus,
  updateVetByClinic,
} from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import { newRoleList } from "../../../util/arrayList";
import { accessList, specialtyList, typeList } from "../../../util/dropList";
import {
  getPharmacyRecordBasedType,
  getTaxAndSubTotalAndTotal,
  getTypeByAppointmentType,
} from "../../../util/function";
import CommonPaymentUpdateModal from "../../Hospital/CommonPaymentUpdateModal/CommonPaymentUpdateModal";
import VetBookAnAppointment from "../BookAppointmentment/VetBookAnAppointment";

const requiredFields = ["name", "role", "conType", "speciality", "access"];

const initialValues = {
  type: "Vet",
  salutation: "Mr",
  name: "",
  speciality: null,
  contactNumber: "",
  conType: [],
  email: "",
  password: "",
  role: null,
  registrationNo: "",
  image: { file: null, previewUrl: null },
  access: [],
};

const initialError = {
  salutation: false,
  name: false,
  speciality: false,
  conType: false,
  contactNumber: false,
  email: false,
  password: false,
  role: false,
  access: false,
};

const initialHelp = {
  salutation: "",
  name: "",
  speciality: "",
  conType: "",
  contactNumber: "",
  email: "",
  password: "",
  role: "",
  access: "",
};

const nameExpan = {
  salutation: "Salutation",
  name: "Name",
  speciality: "Speciality",
  conType: "Consultation Type",
  contactNumber: "Contact Number",
  email: "Email",
  password: "Password",
  role: "role",
  access: "Access",
};

const VetAndUpcomingAppointments = ({
  children,
  vetId,
  left = true,
  active,
  handleEdit,
  handleDelete,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const signRef = useRef();
  const [signedFile, setSignedFile] = useState(null);
  const [conModVisible, setConModVisible] = useState(false);
  const [modalBookVisible, setModalBookVisible] = useState(false);
  const [profileEditModVisible, setProfileEditModVisible] = useState(false);
  const [profileValues, setProfileValues] = useState(initialValues);
  const [profileHelps, setProfileHelps] = useState(initialHelp);
  const [profileError, setProfileError] = useState(initialError);
  const [signModVsble, setSignModVsble] = useState(false);
  const upcomingAppointments = useSelector(
    (state) => state?.clinic?.vetUpcomingAppointments
  );
  const transactions = useSelector((state) => state?.clinic?.transactions);
  const vetDetails = useSelector((state) => state?.clinic?.vet);
  const clinicRoles = useSelector((state) => state?.clinic?.clinicRoles);
  const role = localStorage.getItem("role");
  const defaultUrl = "?filter=all&type=resent";

  useEffect(() => {
    if (vetId) dispatch(getVetDetailsById(vetId));
    if (vetId && left) dispatch(getVetUpcomingAppointmentsById(vetId));
    if (!left) dispatch(getRecentTransactionsPayment(defaultUrl));
  }, []);

  const bookAppointment = (li) => {
    setModalBookVisible(true);
  };

  const checkRoleDoctor = (vet) => {
    const roleDoctor = vetDetails?.userType?.find(
      (usr) => usr?.name === "ROLE_DOCTOR"
    );
    return roleDoctor ? true : false;
  };

  const handleManageSlot = () => {
    navigate(`/manage-slot/${vetId}/4`, { state: { vetId } });
  };

  const updateVetStatus = async () => {
    const apiRes = await dispatch(
      updateVetBlockStatus({
        vetId: vetId ?? vetDetails?.doctorId,
        active: vetDetails?.active === "N" ? "Y" : "N",
      })
    );
    if (apiRes?.payload) dispatch(getVetDetailsById(vetId));
  };

  const conModalOpen = () => {
    setConModVisible(!conModVisible);
  };

  const onApiSuccess = () => {
    dispatch(getVetDetailsById(vetId));
    setConModVisible(!conModVisible);
  };

  const handleEditProfile = () => {
    dispatch(getClinicRoles());
    const roleMap = {
      ROLE_BILLING: "Billing",
      ROLE_CLINICADMIN: "Admin",
      ROLE_DOCTOR: "Vet",
      ROLE_PHARMACY: "Pharmacy Technician",
      ROLE_RECEPTION: "Front Desk",
    };

    const hasDoctor = vetDetails?.userType.some(
      (role) => role.name === "ROLE_DOCTOR"
    );
    const hasClinicAdmin = vetDetails?.userType.some(
      (role) => role.name === "ROLE_CLINICADMIN"
    );

    const updatedUserType =
      hasDoctor && hasClinicAdmin
        ? vetDetails?.userType.filter(
            (role) => role.name !== "ROLE_CLINICADMIN"
          )
        : vetDetails?.userType;

    const accessSelected = updatedUserType.map((ut) => {
      const roleLabel = roleMap[ut.name];
      return accessList.find((al) => al?.value === roleLabel).value;
    });

    setProfileValues({
      ...profileValues,
      type: checkRoleDoctor() ? "Vet" : "Other",
      name: vetDetails?.name,
      speciality:
        specialtyList.find((sl) => sl?.value === vetDetails?.speciality) ??
        null,
      conType: vetDetails?.consulationType,
      email: vetDetails?.email,
      role: newRoleList.find((rl) => rl?.value === vetDetails?.role) ?? null,
      access: accessSelected ?? null,
      salutation: vetDetails?.salutation,
      contactNumber: vetDetails?.mobile,
      registrationNo: vetDetails?.registrationNo ?? "",
      image: { file: null, previewUrl: vetDetails?.image },
      signature: { file: null, previewUrl: vetDetails?.signature },
      department: vetDetails?.department
        ? {
            name: vetDetails?.department,
            value: vetDetails?.department,
          }
        : null,
    });
    setProfileEditModVisible(true);
  };

  const onEditProfileModClose = () => {
    setProfileEditModVisible(!profileEditModVisible);
    setProfileHelps(initialHelp);
    setProfileError(initialError);
  };

  const handleChange = (name, value) => {
    if (name === "conType") {
      setProfileValues({
        ...profileValues,
        conType: typeof value === "string" ? value.split(",") : value,
      });
      return;
    }
    setProfileValues({
      ...profileValues,
      [name]:
        name === "name"
          ? value?.charAt(0).toUpperCase() + value?.slice(1)
          : value,
    });
    if (value === "") {
      setProfileError({ ...profileError, [name]: true });
      setProfileHelps({
        ...profileHelps,
        [name]: `${nameExpan?.[name]} Required Field`,
      });
    }
    if (value !== "") {
      setProfileError({ ...profileError, [name]: false });
      setProfileHelps({ ...profileHelps, [name]: "" });
    }
  };

  const handleValidate = () => {
    let errObj = {},
      hlpObj = {};
    requiredFields.forEach((key) => {
      const reqValue =
        typeof profileValues?.[key] === "string"
          ? profileValues?.[key]
          : profileValues?.[key]?.value ?? profileValues?.[key];
      if (reqValue?.length === 0 || !reqValue) {
        errObj = { ...errObj, [key]: true };
        hlpObj = { ...hlpObj, [key]: "This Field is required" };
      }
    });
    setProfileError({ ...profileError, ...errObj });
    setProfileHelps({ ...profileHelps, ...hlpObj });
    return Object.keys(errObj).length > 0;
  };

  const dataURLtoFile = (dataUrl, filename) => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  };

  const handleUpdate = () => {
    const isNotValid = handleValidate();
    if (isNotValid) return;
    const form = new FormData();
    if (signedFile?.file) {
      form.append("signature", signedFile?.file);
    }
    form.append("name", profileValues.name);
    form.append("email", profileValues.email);
    if (profileValues?.type === "Vet") {
      form.append(
        "salutation",
        profileValues?.type === "Vet" ? "Dr." : profileValues?.salutation
      );
      form.append("speciality", profileValues.speciality?.value);
      form.append("consulationType", profileValues.conType);
      form.append("mobile", profileValues?.contactNumber);
      form.append("role", profileValues?.role?.value);
      if (profileValues?.department?.value) {
        form.append("department", profileValues?.department?.value);
      }
      form.append(
        "access",
        profileValues?.access?.map(
          (ac) => accessList.find(({ value }) => value === ac)?.apiValue
        )
      );
      if (profileValues?.registrationNo !== "") {
        form.append("registrationNo", profileValues?.registrationNo ?? "");
      }
      if (profileValues?.image?.file) {
        form.append("image", profileValues?.image?.file);
      }
    } else {
      form.append("role", profileValues?.role);
    }
    if (profileValues?.type === "Vet") {
      dispatch(updateVetByClinic({ vetId, form })).then((res) => {
        if (res?.payload) {
          dispatch(getVetDetailsById(vetId));
          setProfileEditModVisible(false);
          setProfileValues(initialValues);
        }
      });
    }
  };

  const onUploadFile = (e) => {
    const reader = new FileReader();
    const file = e?.target?.files[0];
    reader.onloadend = () => {
      setProfileValues({
        ...profileValues,
        image: { file: e.target.files[0], previewUrl: reader.result },
      });
    };
    reader.readAsDataURL(file);
  };

  const handleChat = () => {
    dispatch(createNewChat(vetId)).then((res) => {
      if (res?.payload) {
        navigate("/chat", { state: { chatId: res?.payload?.chatId } });
      }
    });
  };

  const handleSave = async () => {
    dispatch(forgotPassword({ emailId: vetDetails?.email }));
  };

  const handleMultiSelect = (event, name) => {
    const {
      target: { value },
    } = event;
    const reqValue =
      name === "access"
        ? value?.includes("Admin")
          ? ["Admin"]
          : value
        : value;
    setProfileValues({
      ...profileValues,
      [name]: reqValue,
    });
    setProfileError({
      ...profileError,
      [name]: reqValue?.length > 0 ? false : true,
    });
    setProfileHelps({
      ...profileHelps,
      [name]: reqValue?.length > 0 ? "" : `${nameExpan?.[name]} Required Field`,
    });
  };

  const getTimeExceed = (apntTime) => {
    return (
      new Date(new Date(apntTime).setHours(new Date(apntTime).getHours() + 1)) <
      new Date()
    );
  };

  const getDraftTransactions = () => {
    return transactions?.filter(
      (tran) =>
        tran?.paymentOption === "draft" &&
        (tran?.type === "Pharmacy" || tran?.type === "Pet Shop") &&
        Number(tran?.balanceDue) > 0 &&
        tran?.status === "unpaid"
    );
  };

  const getUpcomingPastAppointments = ({ upcoming = false, past = false }) => {
    if (upcoming) {
      const reqList = upcomingAppointments?.filter(
        (app) =>
          app?.appoinment?.appointmentStatus?.toLowerCase() === "scheduled" ||
          app?.appoinment?.appointmentStatus?.toLowerCase() === "inprogress" ||
          app?.appoinment?.appointmentStatus?.toLowerCase() === "intransit"
      );
      return reqList;
    }
    if (past) {
      const reqList = upcomingAppointments?.filter(
        (app) =>
          app?.appoinment?.appointmentStatus?.toLowerCase() ===
            "consultation" ||
          app?.appoinment?.appointmentStatus?.toLowerCase() === "finalize" ||
          app?.appoinment?.appointmentStatus?.toLowerCase() === "completed" ||
          app?.appoinment?.appointmentStatus?.toLowerCase() === "canceled" ||
          app?.appoinment?.appointmentStatus?.toLowerCase() === "cancelled"
      );
      return reqList;
    }
  };

  const onCloseSignMod = () => {
    if (signRef.current && !signRef.current.isEmpty()) {
      const dataURL = signRef.current.toDataURL("image/png");
      const file = dataURLtoFile(dataURL, "vetSignature.png");
      setSignedFile({ file, previewUrl: URL.createObjectURL(file) });
      setSignModVsble(false);
    } else {
      console.warn("Signature pad is empty");
    }
  };

  const getDepartments = () => {
    return clinicRoles
      ?.filter((li) => li?.type === "department")
      ?.map((li) => ({
        name: li?.roleName,
        value: li?.roleName,
      }));
  };

  return (
    <>
      <Grid container className="back-white ph20">
        {left ? (
          <Grid
            item
            xs={12}
            sm={12}
            md={2.5}
            lg={2.5}
            xl={2.5}
            className="back-white border-rt"
            style={{ height: "100vh" }}
          >
            <Grid container className="mv20 ph20">
              <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                {vetDetails?.image ? (
                  <img src={vetDetails?.image} alt="" className="img2" />
                ) : (
                  <div className="flex-center h100img brd-r6">
                    <Typography className="font-bold fs30 white-color capitalize">
                      {vetDetails?.name?.[0]}
                    </Typography>
                  </div>
                )}
              </Grid>
              <Grid item xs={8} sm={8} md={8} lg={8} xl={8} className="ph10">
                <Typography className="font-bold capitalize">
                  {checkRoleDoctor() ? "Dr. " : ""} {vetDetails?.name}
                </Typography>
                <Typography className="mb10 txt-regular card-gray-color fs12 capitalize">
                  {vetDetails?.speciality}
                </Typography>
                <div className="flex-row">
                  <div className="flex-center">
                    <Typography
                      className={`mb10 font-bold fs12 ${
                        vetDetails?.active === "Y" ? "blue-color" : "red-color3"
                      }`}
                    >
                      {vetDetails?.active === "Y" ? "Available" : "On Leave"}
                    </Typography>
                    <div className="ml10">
                      <CustomSwitch
                        value={vetDetails?.active === "Y" ? true : false}
                        onChange={updateVetStatus}
                        greenToGray
                      />
                    </div>
                  </div>
                </div>
                <div className="flex-row">
                  {vetDetails?.consulationType?.length > 0 &&
                    vetDetails?.consulationType?.map((ct, i) => (
                      <div
                        key={ct}
                        className={`txt-regular white-color fs8 card-consultation ${
                          ct === "Physical"
                            ? "card-con-blue-back"
                            : ct === "Virtual"
                            ? "virtual-bg-color"
                            : "card-con-gray-back"
                        } ${i !== 0 ? "ml5" : ""}`}
                      >
                        {ct === "Home" ? "Home Visit" : ct}
                      </div>
                    ))}
                </div>
              </Grid>
              <div className="dashed-card mv20 p20">
                <div className="flex-row">
                  <MailIcon
                    sx={{
                      color: AppColors.appPrimary,
                      width: 30,
                      height: 30,
                    }}
                  />
                  <div className="flex-center">
                    <Typography className="txt-regular card-gray-color fs14 ml10 ovrflw-wrp-anywre">
                      {vetDetails?.email}
                    </Typography>
                  </div>
                </div>
                <div className="flex-row mt10">
                  <CallIcon
                    sx={{
                      color: AppColors.appPrimary,
                      width: 30,
                      height: 30,
                    }}
                  />
                  <div className="flex-center">
                    <Typography className="txt-regular card-gray-color fs14 ml10">
                      {vetDetails?.mobile}
                    </Typography>
                  </div>
                </div>
              </div>
              {role !== "ROLE_DOCTOR" && (
                <div className="mb10">
                  <CustomButton
                    text="Chat"
                    leftIcon
                    startIcon={<ChatOutlinedIcon />}
                    onClick={handleChat}
                  />
                </div>
              )}
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="text-bold mb10 fs14">
                  Shortcuts
                </Typography>
              </Grid>
              {checkRoleDoctor() ? (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="flex-row mv5 cursor">
                    <EditIcon
                      sx={{ width: 30, height: 30, color: AppColors.gray2 }}
                    />
                    <div
                      className="ml10 flex-center"
                      onClick={handleEditProfile}
                    >
                      <Typography className="txt-regular fs14">
                        Edit Profile
                      </Typography>
                    </div>
                  </div>
                </Grid>
              ) : null}
              {checkRoleDoctor() ? (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="flex-row mv5 cursor">
                    <CalendarMonthOutlinedIcon
                      sx={{
                        width: 30,
                        height: 30,
                        color:
                          active === "vetCalendar"
                            ? AppColors?.appPrimary
                            : AppColors.gray2,
                      }}
                    />
                    <div
                      className="ml10 flex-center"
                      onClick={() => {
                        navigate("/vet-calendar", {
                          state: { vet: { doctorId: vetId } },
                        });
                      }}
                    >
                      <Typography
                        className={`txt-regular fs14 ${
                          active === "vetCalendar" ? "blue-color" : ""
                        }`}
                      >
                        My calendar
                      </Typography>
                    </div>
                  </div>
                </Grid>
              ) : null}
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div
                  className="flex-row mv5 cursor"
                  onClick={() => {
                    navigate("/manage-availability", { state: { vetId } });
                  }}
                >
                  <InsertInvitationIcon
                    sx={{
                      width: 30,
                      height: 30,
                      color:
                        active === "manageAvailability"
                          ? AppColors?.appPrimary
                          : AppColors.gray2,
                    }}
                  />
                  <div className="ml10 flex-center">
                    <Typography
                      className={`txt-regular fs14 ${
                        active === "manageAvailability" ? "blue-color" : ""
                      }`}
                    >
                      Manage Availability
                    </Typography>
                  </div>
                </div>
              </Grid>

              {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="flex-row mv5 cursor" onClick={handleManageSlot}>
                  <EditCalendarOutlinedIcon
                    sx={{
                      width: 30,
                      height: 30,
                      color:
                        active === "manageSlot"
                          ? AppColors?.appPrimary
                          : AppColors.gray2,
                    }}
                  />
                  <div className="ml10 flex-center">
                    <Typography
                      className={`txt-regular fs14 ${
                        active === "manageSlot" ? "blue-color" : ""
                      }`}
                    >
                      Manage Slots
                    </Typography>
                  </div>
                </div>
              </Grid> */}

              {checkRoleDoctor() ? (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="flex-row mv5 cursor">
                    <CalendarMonthOutlinedIcon
                      sx={{ width: 30, height: 30, color: AppColors.gray2 }}
                    />
                    <div className="ml10 flex-center" onClick={bookAppointment}>
                      <Typography className="txt-regular fs14">
                        Book an appointment
                      </Typography>
                    </div>
                  </div>
                </Grid>
              ) : null}
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="flex-row mv5 cursor">
                  <ChangePasswordIcon
                    style={{
                      width: 30,
                      height: 30,
                      fill: AppColors.gray2,
                    }}
                  />
                  <div className="ml10 flex-center" onClick={handleSave}>
                    <Typography className="txt-regular fs14">
                      Reset Password
                    </Typography>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        ) : null}
        <Grid
          item
          xs={12}
          sm={12}
          md={left ? 7 : 9}
          lg={left ? 7 : 9}
          xl={left ? 7 : 9}
          className="border-rt"
        >
          {children}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={left ? 2.5 : 3}
          lg={left ? 2.5 : 3}
          xl={left ? 2.5 : 3}
          className="back-white"
        >
          <Grid container className={`mv20 ph10 ${!left ? "scroll-90vh" : ""}`}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="text-bold mb10 fs14 blue-color">
                {left ? "Upcoming Appointments" : "Draft Transactions"}
              </Typography>
            </Grid>
            {left ? (
              <>
                <div
                  className="w100Per mb10"
                  style={{
                    height: window.innerHeight / 2 - 75,
                    minHeight: window.innerHeight / 2 - 75,
                    overflowY: "scroll",
                  }}
                >
                  {getUpcomingPastAppointments({ upcoming: true })?.length >
                  0 ? (
                    getUpcomingPastAppointments({ upcoming: true })?.map(
                      (upAp, i) => {
                        const aptmnt = upAp?.appoinment;

                        return (
                          <div
                            className="mv10 upcom-card cursor"
                            key={i + aptmnt?.appointmentId}
                            onClick={() => {
                              navigate(`/clinic-pet-details`, {
                                state: {
                                  appointment: { appoinment: aptmnt },
                                },
                              });
                            }}
                          >
                            <div className="flex-row-ali-cen">
                              <div className="w25Per">
                                {aptmnt?.petImage ? (
                                  <div>
                                    <img
                                      src={aptmnt?.petImage}
                                      alt=""
                                      className="pet-img"
                                    />
                                  </div>
                                ) : (
                                  <div className="flex-center h55w45img">
                                    <Typography className="font-bold fs30 white-color capitalize">
                                      {aptmnt?.petName?.[0]}
                                    </Typography>
                                  </div>
                                )}
                              </div>
                              <div className="w75Per">
                                <div className="flex-row mv3">
                                  <div className="flex-center">
                                    <Typography className="font-bold fs14 capitalize">
                                      {aptmnt?.petName}
                                    </Typography>
                                    <Typography
                                      className={`ml5 font-medium fs14 capitalize ${
                                        aptmnt?.gender === "male"
                                          ? "card-blue-color"
                                          : "card-rose-color"
                                      }`}
                                    >
                                      {`(${aptmnt?.gender})`}
                                    </Typography>
                                  </div>
                                </div>
                                <div className="flex-row mv3">
                                  <div className="flex-center">
                                    <div className="gray-dot" />
                                    <Typography
                                      className={`ml3 font-medium fs12 capitalize ${
                                        upAp?.appointmentType === "Physical" ||
                                        "Virtual"
                                          ? "blue3"
                                          : upAp?.appointmentType ===
                                            "Vaccination"
                                          ? "card-green-color"
                                          : ""
                                      }`}
                                    >
                                      {`${
                                        upAp?.appointmentType === "Physical" ||
                                        "Virtual"
                                          ? "Consultation"
                                          : ""
                                      }`}
                                      {/* {`${
                                    upAp?.appointmentType === "Physical" ||
                                    "Virtual"
                                      ? "Consultation"
                                      : ""
                                  } | ${upAp?.problemType}${
                                    upAp?.problems?.[0]
                                      ? ` - ${upAp?.problems?.[0]}`
                                      : ""
                                  }`} */}
                                    </Typography>
                                  </div>
                                </div>
                                <div className="flex-row mv3">
                                  <div className="flex-center">
                                    <div className="gray-dot" />
                                    <Typography className="ml3 txt-regular card-gray2 fs12">
                                      {aptmnt?.appointmentStartTime ??
                                        moment(
                                          new Date(aptmnt?.appointmentdateTime)
                                        ).format("HH:mm")}
                                    </Typography>
                                  </div>
                                  <div className="flex1-end">
                                    <Typography
                                      className={`txt-regular white-color fs12 upcom-app-box ${
                                        aptmnt?.appointmentType === "Physical"
                                          ? "card-con-blue-back"
                                          : "virtual-bg-color"
                                      }`}
                                    >
                                      {aptmnt?.appointmentType}
                                    </Typography>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {aptmnt?.appointmentStatus === "scheduled" &&
                            getTimeExceed(aptmnt?.appointmentdateTime) ? (
                              <div className="flex-start">
                                <Typography
                                  className={`txt-regular white-color fs12 upcom-app-box card-con-red-back`}
                                >
                                  Unfinished
                                </Typography>
                              </div>
                            ) : (
                              <div className="flex-start">
                                <Typography
                                  className={`txt-regular white-color fs12 upcom-app-box ${
                                    aptmnt?.appointmentStatus?.toLowerCase() ===
                                      "canceled" ||
                                    aptmnt?.appointmentStatus?.toLowerCase() ===
                                      "cancelled"
                                      ? "card-con-red-back"
                                      : "card-top-orange-color"
                                  }`}
                                >
                                  {getTypeByAppointmentType(
                                    aptmnt?.appointmentStatus
                                  )}
                                </Typography>
                              </div>
                            )}
                          </div>
                        );
                      }
                    )
                  ) : (
                    <div className="no-rec">No records available</div>
                  )}
                </div>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography className="text-bold mb10 fs14 blue-color">
                    Past Appointments
                  </Typography>
                </Grid>
                <div
                  className="w100Per"
                  style={{
                    height: window.innerHeight / 2 - 75,
                    minHeight: window.innerHeight / 2 - 75,
                    overflowY: "scroll",
                  }}
                >
                  {getUpcomingPastAppointments({ past: true })?.length > 0 ? (
                    getUpcomingPastAppointments({ past: true })?.map(
                      (upAp, i) => {
                        const aptmnt = upAp?.appoinment;

                        return (
                          <div
                            className="mv10 upcom-card cursor"
                            key={i + aptmnt?.appointmentId}
                            onClick={() => {
                              navigate(`/clinic-pet-details`, {
                                state: {
                                  appointment: { appoinment: aptmnt },
                                },
                              });
                            }}
                          >
                            <div className="flex-row-ali-cen">
                              <div className="w25Per">
                                {aptmnt?.petImage ? (
                                  <div>
                                    <img
                                      src={aptmnt?.petImage}
                                      alt=""
                                      className="pet-img"
                                    />
                                  </div>
                                ) : (
                                  <div className="flex-center h55w45img">
                                    <Typography className="font-bold fs30 white-color capitalize">
                                      {aptmnt?.petName?.[0]}
                                    </Typography>
                                  </div>
                                )}
                              </div>
                              <div className="w75Per">
                                <div className="flex-row mv3">
                                  <div className="flex-center">
                                    <Typography className="font-bold fs14 capitalize">
                                      {aptmnt?.petName}
                                    </Typography>
                                    <Typography
                                      className={`ml5 font-medium fs14 capitalize ${
                                        aptmnt?.gender === "male"
                                          ? "card-blue-color"
                                          : "card-rose-color"
                                      }`}
                                    >
                                      {`(${aptmnt?.gender})`}
                                    </Typography>
                                  </div>
                                </div>
                                <div className="flex-row mv3">
                                  <div className="flex-center">
                                    <div className="gray-dot" />
                                    <Typography
                                      className={`ml3 font-medium fs12 capitalize ${
                                        upAp?.appointmentType === "Physical" ||
                                        "Virtual"
                                          ? "blue3"
                                          : upAp?.appointmentType ===
                                            "Vaccination"
                                          ? "card-green-color"
                                          : ""
                                      }`}
                                    >
                                      {`${
                                        upAp?.appointmentType === "Physical" ||
                                        "Virtual"
                                          ? "Consultation"
                                          : ""
                                      }`}
                                      {/* {`${
                                    upAp?.appointmentType === "Physical" ||
                                    "Virtual"
                                      ? "Consultation"
                                      : ""
                                  } | ${upAp?.problemType}${
                                    upAp?.problems?.[0]
                                      ? ` - ${upAp?.problems?.[0]}`
                                      : ""
                                  }`} */}
                                    </Typography>
                                  </div>
                                </div>
                                <div className="flex-row mv3">
                                  <div className="flex-center">
                                    <div className="gray-dot" />
                                    <Typography className="ml3 txt-regular card-gray2 fs12">
                                      {aptmnt?.appointmentStartTime ??
                                        moment(
                                          new Date(aptmnt?.appointmentdateTime)
                                        ).format("HH:mm")}
                                    </Typography>
                                  </div>
                                  <div className="flex1-end">
                                    <Typography
                                      className={`txt-regular white-color fs12 upcom-app-box ${
                                        aptmnt?.appointmentType === "Physical"
                                          ? "card-con-blue-back"
                                          : "virtual-bg-color"
                                      }`}
                                    >
                                      {aptmnt?.appointmentType}
                                    </Typography>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="flex-start">
                              <Typography
                                className={`txt-regular white-color fs12 upcom-app-box ${
                                  aptmnt?.appointmentStatus?.toLowerCase() ===
                                    "canceled" ||
                                  aptmnt?.appointmentStatus?.toLowerCase() ===
                                    "cancelled"
                                    ? "card-con-red-back"
                                    : aptmnt?.appointmentStatus?.toLowerCase() ===
                                      "completed"
                                    ? "card-con-green-back"
                                    : aptmnt?.appointmentStatus?.toLowerCase() ===
                                        "consultation" ||
                                      aptmnt?.appointmentStatus?.toLowerCase() ===
                                        "finalize"
                                    ? "card-top-yellow-color"
                                    : "card-top-orange-color"
                                }`}
                              >
                                {getTypeByAppointmentType(
                                  aptmnt?.appointmentStatus
                                )}
                              </Typography>
                            </div>
                          </div>
                        );
                      }
                    )
                  ) : (
                    <div className="no-rec">No records available</div>
                  )}
                </div>
              </>
            ) : getDraftTransactions()?.length > 0 ? (
              getDraftTransactions()?.map((tran, i) => {
                return (
                  <div
                    className="mv10 upcom-card-wo-back flex-start"
                    key={tran?.paymentId}
                  >
                    <div className="flex-row-ali-cen w100Per">
                      <div className="flex-start">
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {tran?.userName?.[0]}
                          </Typography>
                        </div>

                        <div className="flex-column ml10 spa-around">
                          <Custom3dotString
                            str={tran?.userName}
                            className="font-bold fs12"
                            length={8}
                          />
                          <div className="gray18 txt-regular fs10">
                            {moment(tran?.createdDate).format("DD MMM YYYY")}
                          </div>
                        </div>
                      </div>

                      <div className="flex1-end">
                        <div className="paymentstatuspaid">
                          Rs{" "}
                          {Number(
                            getTaxAndSubTotalAndTotal(
                              getPharmacyRecordBasedType(tran?.paymentDetails)
                            )?.subTotal - Number(tran?.amtPaid ?? 0)
                          )?.toFixed(2)}
                        </div>

                        <img
                          src={require("../../../assets/images/png/edit.png")}
                          alt=""
                          className="imghw30 ml5 cursor"
                          onClick={() => handleEdit(tran)}
                        />

                        <img
                          src={require("../../../assets/images/png/delete.png")}
                          alt=""
                          className="imghw30 ml5 cursor"
                          onClick={() => handleDelete(tran)}
                        />
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="no-reco">No records available</div>
            )}
          </Grid>
        </Grid>
      </Grid>
      {conModVisible ? (
        <CommonPaymentUpdateModal
          open={conModVisible}
          onClose={conModalOpen}
          onApiSuccess={onApiSuccess}
          vet={vetDetails}
        />
      ) : null}
      {modalBookVisible ? (
        <VetBookAnAppointment
          modalVisible={modalBookVisible}
          setBookModVisible={setModalBookVisible}
          selectedVet={vetDetails}
        />
      ) : null}

      <CustomModal
        open={profileEditModVisible}
        onClose={onEditProfileModClose}
        header="Edit Profile"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh">
          <Grid container spacing={1} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mb30">
              <CustomUpload
                uploadText="Profile Picture"
                onUploadFile={onUploadFile}
                value={profileValues?.image?.previewUrl}
                profileImg
                imageHeight={140}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14 fw-600 ">
              Name <span className="red-color"> *</span>
            </div> */}
              <div className="mb20">
                <CustomTextField
                  name="name"
                  fullWidth
                  handleChange={(e) => handleChange("name", e?.target?.value)}
                  required={true}
                  label="Name"
                  value={profileValues?.name}
                  helperText={profileHelps?.name}
                  error={profileError?.name}
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14 fw-600">
              Role <span className="red-color"> *</span>
            </div> */}
              <div className="mb20">
                <Select
                  list={newRoleList}
                  value={profileValues?.role}
                  handleChange={(e, value) => handleChange("role", value)}
                  error={profileError?.role}
                  helperText={profileHelps?.role}
                  label="Role *"
                  search
                />
              </div>
            </Grid>

            {profileValues?.type === "Vet" ? (
              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                {/* <div className="txt-mont fs14 fw-600 ">
                Speciality <span className="red-color"> *</span>
              </div> */}
                <div className="mb20">
                  <Select
                    list={specialtyList}
                    value={profileValues?.speciality}
                    handleChange={(e, value) =>
                      handleChange("speciality", value)
                    }
                    name="speciality"
                    label="Speciality *"
                    error={profileError?.speciality}
                    helperText={profileHelps?.speciality}
                    search
                  />
                </div>
              </Grid>
            ) : null}
            {profileValues?.type === "Vet" ? (
              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                {/* <div className="txt-mont fs14 fw-600 ">
                Consultation Type <span className="red-color"> *</span>
              </div> */}
                <div className="mb20">
                  <Select
                    list={typeList}
                    value={profileValues?.conType}
                    handleChange={(e) =>
                      handleChange("conType", e?.target?.value)
                    }
                    multiSelectTagCheck
                    error={profileError?.conType}
                    helperText={profileHelps?.conType}
                    label="Consultation Type *"
                  />
                </div>
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mb10">
                <Select
                  list={getDepartments()}
                  value={profileValues?.department}
                  handleChange={(e, value) => handleChange("department", value)}
                  required
                  label="Department"
                  search
                  error={profileError?.department}
                  helperText={profileHelps?.department}
                  disabled={role !== "ROLE_CLINIC"}
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {/* <div className="txt-mont fs14 fw-600 ">
              Email <span className="red-color"> *</span>
            </div> */}
              <div className="mb20">
                <CustomTextField
                  name="email"
                  fullWidth
                  handleChange={(e) => handleChange("email", e?.target?.value)}
                  value={profileValues?.email}
                  helperText={profileHelps?.email}
                  error={profileError?.email}
                  label="Email"
                  required={true}
                  disabled
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {/* <div className="txt-mont fs14 fw-600 ">
              Access <span className="red-color">*</span>
            </div> */}
              <div className="mb20">
                <Select
                  list={accessList}
                  value={profileValues?.access}
                  handleChange={(e) => handleMultiSelect(e, "access")}
                  multiSelectTagCheck
                  label="Access *"
                  error={profileError?.access}
                  helperText={profileHelps?.access}
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14 fw-600 ">Phone Number</div> */}
              <div className="">
                <CustomTextField
                  value={profileValues?.contactNumber}
                  handleChange={(e) =>
                    handleChange("contactNumber", e?.target?.value)
                  }
                  name="Contact Number"
                  error={profileError?.contactNumber}
                  fullWidth
                  helperText={profileHelps?.contactNumber}
                  label="Phone Number"
                  disabled
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14 fw-600 ">Registration No.</div> */}
              <div className="">
                <CustomTextField
                  value={profileValues?.registrationNo}
                  handleChange={(e) =>
                    handleChange("registrationNo", e?.target?.value)
                  }
                  fullWidth
                  label="Registration No."
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 balck mt10">Signature</div>
              {signedFile?.previewUrl ??
              profileValues?.signature?.previewUrl ? (
                <img
                  className="h50"
                  alt=""
                  src={
                    signedFile?.previewUrl ??
                    profileValues?.signature?.previewUrl
                  }
                />
              ) : null}
              <Typography
                className="fs14 blue-color font-bold cursor"
                onClick={() => {
                  setSignModVsble(true);
                }}
              >
                {profileValues?.signature?.previewUrl ? "Update" : "Add"}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end">
                <div className="w20Per mt20">
                  <CustomButton text="Update" onClick={handleUpdate} smallBtn />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={signModVsble}
        onClose={() => setSignModVsble(false)}
        header="Signature"
        modal
        modalWidth={70}
      >
        <SignatureCanvas
          ref={signRef}
          canvasProps={{
            width: (window.innerWidth / 100) * 65,
            height: 300,
            className: "sigCanvas",
          }}
        />
        <div className="flex-center">
          <div>
            <CustomButton text="Save" smallBtn onClick={onCloseSignMod} />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default VetAndUpcomingAppointments;
